export const PONTO_VENDA_LOADING = 'PONTO_VENDA_LOADING';
export const PONTO_VENDA_FAIL = 'PONTO_VENDA_FAIL';
export const PONTO_VENDA_SUCCESS = 'PONTO_VENDA_SUCCESS';
export const PONTO_VENDA_FILTER = 'PONTO_VENDA_FILTER';

export type PontoVenda = {
  id: string;
  pv: number;
  nomePontoVenda: string;
  cnpjPv: string;
  status: string;
};

export type FilterPontosVenda = {
  filter: string;
  type: 'N' | 'C';
};

export interface PontoVendaLoading {
  type: typeof PONTO_VENDA_LOADING;
}

export interface PontoVendaFail {
  type: typeof PONTO_VENDA_FAIL;
  payload: string;
}

export interface PontoVendaSuccess {
  type: typeof PONTO_VENDA_SUCCESS;
  payload: PontoVenda[];
}

export interface PontosVendaFilter {
  type: typeof PONTO_VENDA_FILTER;
  payload: FilterPontosVenda;
}

export type PontoVendaDispatchTypes =
  | PontoVendaLoading
  | PontoVendaFail
  | PontoVendaSuccess
  | PontosVendaFilter;
